<template>

  <t-page>

    <TypeChecklistItemCategoryDialog :no-option-add="noOptionAdd" @onSubmit="onTypeChecklistItemCategoryDialog"/>

    <t-page-form tabs :submit-text="currentPage.singularTitle"
                 :title="t('form-of')+currentPage.pageTitle"
                 :command="command" :status="status" :generalErrors="generalErrors" @onSubmit="onSubmit"
                 :check-errors-again="checkErrorsComponent"
                 :set-tab-index="tabIndex"
                 :go-back-title="t('go-back-list')" :go-back-to="currentPage.name" :busy="!pageFormIsLoaded">

      <template>

        <t-form-tab title="Dados Básicos">

          <t-input v-model="form.typeChecklistItemId" hidden/>

          <b-row>

            <t-input v-model="form.name" cols="9" :add-error="error.name" label="Tipo de Item" required/>

            <t-input v-model="form.typeChecklistItemCodeLabel"
                     v-if="modeCodeLabel === SettingType.mode.MODE_CODE_LABEL_MANUAL"
                     :add-error="error.typeChecklistItemCodeLabel" upper cols="3"
                     label="Cód. Item"
                     help="Código inserido manualmente conforme configurado em Checklists > Configurações > Parâmetros"
                     required/>

            <t-input v-model="form.typeChecklistItemCodeLabel"
                     v-else-if="modeCodeLabel === SettingType.mode.MODE_CODE_LABEL_AUTOMATIC_DEFAULT"
                     :add-error="error.typeChecklistItemCodeLabel" upper cols="3"
                     fixed
                     label="Cód. Item"
                     help="Código inserido automaticamente conforme configurado em Checklists > Configurações > Parâmetros"
            />

          </b-row>

          <b-row>

            <t-input
                v-model="form.typeChecklistItemCategoryId"
                label="Categoria"
                cols="6"
                :options="typeChecklistItemCategoryOptions" select>
              
              <template #no-options="{search}">
                <b-link @click="addNoOption('modal-type-checklist-item-category',search)">Cadastrar Categoria</b-link>
              </template>

              <template #input-group-append>
                <t-button title="Adicionar nova Categoria" @click="openDialogForm('modal-type-checklist-item-category')"
                          icon-plus/>
              </template>


            </t-input>


            <b-col cols="6">

              <label>Anomalia padrão
                <t-help
                    title="Utilizado para pré-selecionar automaticamente uma anomalia relacionada a um apontamento novo deste item"/>
              </label>
              <t-input-code-label type-pathology
                                  :status="status"
                                  :command="command"
                                  hide-label
                                  v-model="form.defaultTypePathologyId"/>

            </b-col>

          </b-row>

          <t-input v-model="form.unit" radio :options="UnitType.list" help="Especifique caso desejar pré-selecionar uma unidade de medida padrão em relação ao item para novos apontamentos." label="Un. Medida" />

          <t-input v-model="form.note" label="Observações" max-length="500" textarea/>

          <t-input v-model="form.integrationTag" label="Código de Integração" help="Por padrão não é utilizado, porém poderá ser utilizado em integrações e aplicações especiais." />

          <!--
          RETIRADO EM 15/01/2025, POIS GERA INCONSISTÊNCIA COM APONTAMENTOS ANTIGOS, SENDO NECESSÁRIO ALGUMA FERRAMENTA DE MIGRAÇÃO DE ITENS DE APONTAMENTOS EM MASSA.
          INDICANDO O NOVO ITEM QUE SUBSTITUIRA O ANTIGO QUE SERÁ INATIVO.
          <t-input-status v-model="form.status"/>
          -->

        </t-form-tab>

        <t-form-tab title="Anomalias" hash="pathology">

          <b-form-checkbox class="col-sm-12 ml-2 mb-3 mt-3" v-model="form.enableAllPathologies" switch>
            Habilitar todas as anomalias para este tipo de item?
            <t-help
                title="Você poderá especificar quais as anomalias podem ser utilizadas neste itens, basta desmarcar esta opção e especificar quais as anomalias abaixo."/>
          </b-form-checkbox>

          <t-table
              class="mb-2"
              enable-checked
              v-show="!form.enableAllPathologies"
              v-model="pathologiesIds"
              :items="pathologiesList"
              :fields="viewFieldsPagePathology"
              :command="command"
              title-items="Pathology"
              link-primary-column="name"
              table-bordered
              disable-actions-column
              enable-search
              primary-key-column="typePathologyId">

            <template #first-column="{item}">
              {{ item.name }}
            </template>

          </t-table>

        </t-form-tab>

      </template>

    </t-page-form>

  </t-page>

</template>

<script>

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import TypePathologyService from "@/services/modules/checklist/TypePathology.service";
import ui from "@/assets/scripts/ui";
import SettingType from "@/model/types/resource/SettingType";
import TypeChecklistItemCategoryService from "@/services/modules/checklist/TypeChecklistItemCategory.service";
import TypeChecklistItemCategoryDialog from "@/views/modules/checklist/TypeChecklistItemCategoryDialog";
import UnitType from "@/model/types/modules/general/UnitType";

export default {
  mixins: [pageDefaultMixin, pageFormMixin],
  components: {TypeChecklistItemCategoryDialog},
  name: 'TypeChecklistItemForm',
  data() {
    return {
      UnitType,
      SettingType,
      path: "", //Utilizar somente quando fora do padrão
      genKey: false, //Utilizar quando desejar gerar chave temporária
      enableGeneralFields: false,
      fieldKey: "typeChecklistItemId",
      form: {
        typeChecklistItemId: 0,
        typeChecklistItemNumber: 0,
        typeChecklistItemCategoryId: 0,
        typeChecklistItemCodeLabel: "",
        defaultTypePathologyId: 0,
        enableAllPathologies: true,
        integrationTag: "",
        name: "",
        unit: "",
        note: "",
        status: 1,
        pathologies: [],
      },
      error: {//Campos que podem receber retorno de erro do backend
        typeChecklistItemCodeLabel: "",
        name: ""
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      noOptionAdd: "", //Usado para armazenar o começo do nome digitado para inserção rápida em dialogos na página.
      modeCodeLabel: "",
      tabIndex: 0,
      pathologiesIds: [],
      pathologiesList: [],
      typeChecklistItemCategoryOptions: [],
      viewFieldsPagePathology: [
        {key: "name", note: "", label: "Anomalia"},
        {key: "sector", note: "", label: "Categoria"},
        {key: "note", note: "", label: "Obs."},
      ],
      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {


    },
    async mountedContinued() {

      this.modeCodeLabel = this.getRenderRule(SettingType.render.RENDER_TAG_COD_LABEL)

      await TypeChecklistItemCategoryService.selectList().then((list) => {
        this.typeChecklistItemCategoryOptions = list
      }).catch(error => this.responseError(error))

      await TypePathologyService.getAllPathologies().then((list) => {
        this.pathologiesList = list
      }).catch(error => this.responseError(error))

      this.pathologiesIds = this.convertObjectToArrayIds(this.form.pathologies, "typePathologyId")

      this.pageFormIsLoaded = true

    },
    async onSubmit() {

      this.form.pathologies = this.convertArrayIdsToObject(this.pathologiesIds, "typePathologyId")

      if (!this.isDelete() && !this.form.enableAllPathologies && this.form.pathologies.length === 0) {
        ui.msgError(this, "Selecione pelo menos 1 anomalia a este Tipo de Item para poder continuar ou desmarque a opção de especificar quais anomalias desejadas.", () => {
          this.tabIndex = 1
        })
      } else {
        await this.setSendingDefault()
      }


    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    onTypeChecklistItemCategoryDialog(itemInserted) {

      this.form.typeChecklistItemCategoryId = itemInserted.value
      this.typeChecklistItemCategoryOptions.push(itemInserted); //Simples, pois é uma lista não agrupada

    },

    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedForm(true, false)

    await this.mountedContinued()

  }

}
</script>

